module.exports = __webpack_public_path__ + "img/runflow_logo.f4b337a6.png";